import { render, staticRenderFns } from "./EMelderComponentMeldenBs11Kontrollkästchen.vue?vue&type=template&id=ee221392"
import script from "./EMelderComponentMeldenBs11Kontrollkästchen.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs11Kontrollkästchen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports